import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import SidePanel from "./components/sidePanel/SidePanel";

function App() {
  return (
    <div>
      <Main />
      <SidePanel />
    </div>
  );
}

export default App;
